// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"6a561f40","100":"cbab22ed","152":"9f9157eb","173":"e98c83ad","457":"01add86b","719":"a055f781","899":"8c700483","973":"0e3b53fe"}[chunkId] + ".chunk.js";
};